goog.provide("shadow.js.shim.module$src$svg$weather$cloud_arrow_up_svg");
goog.provide("module$shadow_js_shim_module$src$svg$weather$cloud_arrow_up_svg");
shadow.js.shim.module$src$svg$weather$cloud_arrow_up_svg = shadow.js.nativeProvides["src/svg/weather/cloud-arrow-up.svg"] = shadow$bridge("src/svg/weather/cloud-arrow-up.svg");
module$shadow_js_shim_module$src$svg$weather$cloud_arrow_up_svg.default = shadow.js.shim.module$src$svg$weather$cloud_arrow_up_svg;
